<template>
	<div class="opinion d-flex">
		<div>
			<img 
				:src="opinion.additionalInformation.customerImage" 
				:alt="opinion.additionalInformation.name"
				class="opinion-avatar">
		</div>
		<div>
			<div class="d-flex align-center">
				<p class="opinion-name">{{opinion.additionalInformation.name}}</p>
				<img 
					:src="opinion.nationality" 
					:alt="opinion.nationality"
					class="mr-2 opinion-nationality"
				>
				<div>
					<el-rate
						:colors="colors" 
						v-model="opinion.rating"
						disabled
					>
					</el-rate>
				</div>
			</div>
			<div class="opinion-text">{{opinion.description}}</div>
		</div>
	</div>
</template>
<script>
function data() {
	return {
		colors: ['#2c404a', '#2c404a', '#2c404a'],
	};
}
export default {
	name: 'opinion',
	data,
	props: {
		opinion: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
<style lang="scss" scoped>
	.opinion {
		border: 0.1rem solid color(border-grey-light);
		border-radius: 0.3rem;
		margin-bottom: 2.2rem;
		padding: 3.1rem 2.2rem;
	}
	.opinion-avatar {
		height: 9.1rem;
		width: 9.1rem;
		margin-right: 2.2rem;
	}

	.opinion-name {
		font-family: font(open-semibold);
		font-size: size(maxsmall);
		margin-right: 1rem;
	}

	.opinion-text {
		color: color(text-grey-bold);
		font-size: size(maxsmall);
	}

	.opinion-nationality {
		height: 1.3rem;
	}

	@media screen and (max-width: 1024px) {
		.opinion-avatar, .opinion-nationality {
			display: none;
		}

		.opinion {
			padding: 1rem 2.2rem;
		}

		.opinion-name, .opinion-text {
			font-size: size(normal);
		}
	}
</style>





// WEBPACK FOOTER //
// opinion.vue?909ab95a